/**
 * Resolves which sidebar menu key should be highlighted for the current
 * route in `MainLayout` (2026-08-14 走查报告): detail/child pages (e.g. a
 * single test suite, an endpoint's rule page, a Mission report) don't have
 * their own menu entry, so a plain `location.pathname === key` check leaves
 * the sidebar with nothing selected while browsing them. Exact matches
 * against a real menu key always win — `/workspaces/:id/settings` IS the
 * "成员管理" submenu's own key (see `MainLayout`'s `menuItems`), so it must
 * win as itself rather than being redirected to "我的工作区"; a prior
 * special-case did exactly that and caused clicking "成员管理" to highlight
 * "我的工作区" instead. Everything else falls through to a path-prefix →
 * parent-menu-key mapping, which also catches `/workspaces/:otherId/...`
 * pages that aren't the current workspace's own known keys. Pure, no
 * React/router import.
 */

const PREFIX_RULES: ReadonlyArray<{ prefix: string; key: string }> = [
  { prefix: '/comparison/api/suites/', key: '/comparison/api/suites' },
  { prefix: '/comparison/api/suite-runs/', key: '/comparison/api/suites' },
  { prefix: '/comparison/api/rules/', key: '/comparison/api/endpoints' },
  { prefix: '/comparison/api/runs/', key: '/comparison/api/endpoints' },
  { prefix: '/verifications/', key: '/commerce/verifications' },
  { prefix: '/commerce/', key: '/commerce/verifications' },
  { prefix: '/workspaces/', key: '/workspaces' },
  { prefix: '/browser-captures/', key: '/workspaces' },
  { prefix: '/settings/browser-extension/pair', key: '/workspaces' },
];

export function resolveMainLayoutSelectedKey(
  pathname: string,
  knownMenuKeys: readonly string[],
  _workspaceId: number | null
): string {
  if (knownMenuKeys.includes(pathname)) {
    return pathname;
  }
  for (const rule of PREFIX_RULES) {
    if (pathname.startsWith(rule.prefix)) {
      return rule.key;
    }
  }
  return pathname;
}
